var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.formValidate.id === 0 ? "新增限购规则" : "编辑限购规则",
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.cancelVisible,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "105px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "限购类型:", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: {
                        placeholder: "请选择限购类型",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.formValidate.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValidate, "type", $$v)
                        },
                        expression: "formValidate.type",
                      },
                    },
                    _vm._l(_vm.returnArr, function (item, index) {
                      return _c("el-option", {
                        key: index.code,
                        attrs: { value: item.code, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "限购规则名称:", prop: "typeName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入卡限购规则名称",
                      maxlength: "32",
                      size: "small",
                      clearable: "",
                    },
                    model: {
                      value: _vm.formValidate.typeName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formValidate,
                          "typeName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formValidate.typeName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "限购数量:", prop: "count" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      size: "small",
                      "controls-position": "right",
                      min: 1,
                    },
                    model: {
                      value: _vm.formValidate.count,
                      callback: function ($$v) {
                        _vm.$set(_vm.formValidate, "count", $$v)
                      },
                      expression: "formValidate.count",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancelVisible } }, [
                _vm._v("取消"),
              ]),
              _vm.checkPermi(["merchant:product:update"])
                ? _c(
                    "el-button",
                    {
                      staticClass: "submission",
                      attrs: { type: "primary", loading: _vm.loadingBtn },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formValidate")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }